var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 8.33317H15.8327C17.4993 8.33317 18.3327 7.49984 18.3327 5.83317V4.1665C18.3327 2.49984 17.4993 1.6665 15.8327 1.6665H14.166C12.4993 1.6665 11.666 2.49984 11.666 4.1665V5.83317C11.666 7.49984 12.4993 8.33317 14.166 8.33317Z",
    stroke: "#BB8D0B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 18.3332H5.83268C7.49935 18.3332 8.33268 17.4998 8.33268 15.8332V14.1665C8.33268 12.4998 7.49935 11.6665 5.83268 11.6665H4.16602C2.49935 11.6665 1.66602 12.4998 1.66602 14.1665V15.8332C1.66602 17.4998 2.49935 18.3332 4.16602 18.3332Z",
    stroke: "#BB8D0B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99935 8.33317C6.8403 8.33317 8.33268 6.84079 8.33268 4.99984C8.33268 3.15889 6.8403 1.6665 4.99935 1.6665C3.1584 1.6665 1.66602 3.15889 1.66602 4.99984C1.66602 6.84079 3.1584 8.33317 4.99935 8.33317Z",
    stroke: "#BB8D0B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9993 18.3332C16.8403 18.3332 18.3327 16.8408 18.3327 14.9998C18.3327 13.1589 16.8403 11.6665 14.9993 11.6665C13.1584 11.6665 11.666 13.1589 11.666 14.9998C11.666 16.8408 13.1584 18.3332 14.9993 18.3332Z",
    stroke: "#BB8D0B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.89128b79c0a7a220528ce7d84e2846f6.svg";
export { ForwardRef as ReactComponent };